// ABOUTME: Lets a platform request card ask the composer to start a message about
// it ("Change") without threading a callback through every transcript layer.

const EVENT = 'maxflow:compose-about-request'

export function composeAboutRequest(text: string): void {
  window.dispatchEvent(new CustomEvent<string>(EVENT, { detail: text }))
}

export function onComposeAboutRequest(handler: (text: string) => void): () => void {
  const listener = (e: Event) => handler((e as CustomEvent<string>).detail)
  window.addEventListener(EVENT, listener)
  return () => window.removeEventListener(EVENT, listener)
}
